const loadablePreloadRegistry = new Set();
export function addPreload(component) {
  loadablePreloadRegistry.add(component);
}
function removePreload(component) {
  loadablePreloadRegistry.delete(component);
}

/**
 * Preloads all Loadable components that have been created.
 *
 * Used by foundations-components-test-utils test lifecycle hooks to ensure tests consistency
 */
export async function preloadAllLoadables() {
  for (const preload of loadablePreloadRegistry.values()) {
    await preload().catch(error => {
      console.error('Error preloading Loadable component', error);
    }).finally(() => {
      removePreload(preload);
    });
  }

  // One Loadable component may add another Loadable component to the registry, and so on
  if (loadablePreloadRegistry.size > 0) {
    return preloadAllLoadables();
  }
}